import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { CreateRenderGroupRequest, DesignRenderGroup, Page, RenderGroupListParams } from "./dtos";

const DESIGN_RENDER_GROUP_SERVICE = `${Constants.API_URL}/bedrock/design_render_groups`;

export class DesignRenderGroupServices {
  /** Resolves to the group on both 202 (new render) and 200 (an identical recent group was reused). */
  @scCatchServiceException(true)
  static async create(request: CreateRenderGroupRequest): Promise<DesignRenderGroup> {
    const { data } = await axios.post<DesignRenderGroup>(DESIGN_RENDER_GROUP_SERVICE, request);
    return data;
  }

  @scCatchServiceException(true)
  static async get(id: number): Promise<DesignRenderGroup> {
    const { data } = await axios.get<DesignRenderGroup>(`${DESIGN_RENDER_GROUP_SERVICE}/${id}`);
    return data;
  }

  @scCatchServiceException(true)
  static async list(params: RenderGroupListParams): Promise<Page<DesignRenderGroup>> {
    const { reviewIds, ...rest } = params;
    const { data } = await axios.get<Page<DesignRenderGroup>>(DESIGN_RENDER_GROUP_SERVICE, {
      params: { ...rest, reviewIds: reviewIds ? reviewIds.join(",") : undefined },
    });
    return data;
  }

  /** Attaches a caption written after the render started; review designs only. */
  @scCatchServiceException(true)
  static async update(id: number, request: { caption: string }): Promise<DesignRenderGroup> {
    const { data } = await axios.patch<DesignRenderGroup>(`${DESIGN_RENDER_GROUP_SERVICE}/${id}`, request);
    return data;
  }

  @scCatchServiceException(true)
  static async regenerateCaption(id: number): Promise<DesignRenderGroup> {
    const { data } = await axios.post<DesignRenderGroup>(`${DESIGN_RENDER_GROUP_SERVICE}/${id}/regenerate_caption`);
    return data;
  }
}
